var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "13", height: "12", viewBox: "0 0 13 12", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg2585453934a)" },
      React.createElement("path", { d: "M11.532 4.1H6.934V.633A.456.456 0 0 0 6.476.18H5.61a.456.456 0 0 0-.458.454V4.1H.554A.552.552 0 0 0 0 4.65v1.185c0 .303.248.55.554.55h.08l.623 4.403a1.211 1.211 0 0 0 1.197 1.033h7.178c.598 0 1.113-.444 1.196-1.033l.624-4.404h.08a.552.552 0 0 0 .554-.55V4.65a.552.552 0 0 0-.554-.55zM5.634.657h.818v4.566h-.818V.657zm4.717 10.065a.729.729 0 0 1-.72.62H2.455a.729.729 0 0 1-.72-.62L1.12 6.384h9.846l-.614 4.338zm1.253-4.887c0 .04-.032.071-.072.071H.554a.072.072 0 0 1-.073-.071V4.649c0-.04.033-.071.073-.071h4.598v.669c0 .25.205.454.457.454h.867a.456.456 0 0 0 .458-.454v-.67h4.598c.04 0 .072.033.072.072v1.186z" }),
      React.createElement("path", { d: "M2.6 6.944a.24.24 0 0 0-.24.24v3.346a.24.24 0 0 0 .24.239.24.24 0 0 0 .24-.24V7.184a.24.24 0 0 0-.24-.239zM3.977 6.944a.24.24 0 0 0-.24.24v3.346a.24.24 0 0 0 .24.239.24.24 0 0 0 .241-.24V7.184a.24.24 0 0 0-.24-.239zM5.354 6.944a.24.24 0 0 0-.24.24v3.346a.24.24 0 0 0 .24.239.24.24 0 0 0 .241-.24V7.184a.24.24 0 0 0-.24-.239zM6.731 6.944a.24.24 0 0 0-.24.24v3.346a.24.24 0 0 0 .24.239.24.24 0 0 0 .241-.24V7.184a.24.24 0 0 0-.24-.239zM8.108 6.944a.24.24 0 0 0-.24.24v3.346a.24.24 0 0 0 .24.239.24.24 0 0 0 .241-.24V7.184a.24.24 0 0 0-.24-.239zM9.486 6.944a.24.24 0 0 0-.241.24v.19a.24.24 0 0 0 .24.24.24.24 0 0 0 .241-.24v-.19a.24.24 0 0 0-.24-.24zM9.486 8.044a.24.24 0 0 0-.241.239v2.247a.24.24 0 0 0 .24.239.24.24 0 0 0 .241-.24V8.284a.24.24 0 0 0-.24-.24z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg2585453934a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h12.086v12H0z" })
      )
    )
  );
});